import React, { useState } from "react";

import Banner from "../components/Banner";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import landingAsset from "../utils/assetPaths";

interface StatsButton {
    label: string;
    value: string;
    component: string;
}

const Stats: React.FC = () => {
    const [activeButton, setActiveButton] = useState("topPlayer");

    const buttons: StatsButton[] = [
        {
            label: "Top Players",
            value: "topPlayer",
            component: "Top player metrics coming soon...",
        },
        {
            label: "Top Leagues",
            value: "topLeague",
            component: "League rankings analysis in progress...",
        },
        {
            label: "New Rising Stars",
            value: "newPlayer",
            component: "Discover the newest talent on SACA...",
        },
    ];

    const handleButtonClick = (value: string) => {
        setActiveButton(value);
    };

    return (
        <>
            <Navbar />
            <div
                style={{
                    backgroundImage: `url(${landingAsset("herobg.svg")})`,
                    backgroundSize: "cover",
                }}
                className="h-[500px] md:h-[400px] relative w-full flex justify-center items-center flex-col "
            >
                <div
                    style={{
                        background:
                            "linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 17.83%)",
                    }}
                    className=" h-full w-full absolute left-0 top-0"
                >
                    <div className=" w-full h-full flex flex-col items-center text-center justify-center p-4">
                        <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-black font-Manrope uppercase tracking-tight">SACA Stats</h1>
                        <p className=" mt-6 text-center font-Manrope text-lg md:text-xl text-white/90 max-w-3xl leading-relaxed">
                            Real-time insights and benchmarks. Discover outstanding players and leagues based on verified statistical achievements.
                        </p>
                    </div>
                </div>
            </div>

            <div className=" flex flex-col items-center py-20 w-full px-4 md:px-14 bg-white">
                <div className="max-w-4xl w-full mx-auto">
                    <div className="flex flex-wrap gap-4 border-b-2 border-gray-100 w-full mb-12">
                        {buttons.map((button, index) => (
                            <button
                                key={index}
                                className={`font-black font-Manrope text-sm md:text-base pb-6 px-4 md:px-8 transition-all relative ${activeButton === button.value
                                    ? "text-green-700 border-b-4 border-green-700 -mb-[2px]"
                                    : "text-gray-400 hover:text-gray-600"
                                    }`}
                                onClick={() => handleButtonClick(button.value)}
                            >
                                {button.label}
                            </button>
                        ))}
                    </div>

                    <div className="p-16 bg-gray-50 rounded-[48px] border-2 border-dashed border-gray-200 text-center">
                        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-8 animate-pulse text-3xl">
                            📊
                        </div>
                        <h3 className="text-2xl font-black text-gray-900 mb-4">Analytics Engine Active</h3>
                        <p className="font-Manrope font-bold text-gray-500 text-lg leading-relaxed max-w-xl mx-auto">
                            {buttons.find((button) => button.value === activeButton)?.component}
                        </p>
                        <div className="mt-10 flex justify-center gap-3">
                            {[1, 2, 3].map(i => <div key={i} className="w-3 h-3 rounded-full bg-green-700 animate-bounce" style={{ animationDelay: `${i * 0.2}s` }} />)}
                        </div>
                    </div>
                </div>
            </div>

            <Banner />
            <Footer />
        </>
    );
};

export default Stats;
